export default __webpack_public_path__ + "static/devops-adoption-a44cb4bc65c93dfa8fa404e38f05233a.webp";